import React from 'react'
import { MalwareSummary } from './MalwareSummary'
import { MalwareAssociations } from './MalwareAssociations'
import { MalwareCapabilities } from './MalwareCapabilities'
import { MalwareDetectionNames } from './MalwareDetectionNames'
import { Box } from '@maui/elements'
import { ViewObjectLinks } from '@/components/modals/ViewObjectLinks'

export const MalwareModalDetails = ({ malware }) => {
  return (
    <Box m="-16px">
      <MalwareSummary
        malware={malware}
        headerSlot={malware && <ViewObjectLinks path={`/malware/${malware.id}`} />}
      />
      <MalwareAssociations malware={malware} />
      <MalwareCapabilities malware={malware} />
      <MalwareDetectionNames malware={malware} />
    </Box>
  )
}
